export default {"src":"/_next/static/media/section5.1b2fbc8a.svg","height":397,"width":487,"blurWidth":0,"blurHeight":0};